import type { Assessment } from '@seen/core/models/assessments/assessment'
import { Participant } from '@seen/core/models/patients/participant'
import { isSameDay } from 'date-fns'
import type { JSX } from 'react'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { useRead } from '#src/hooks/useRead.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'

interface AssessmentItemProps {
  assessment: Assessment
}

export function AssessmentItem({
  assessment,
}: AssessmentItemProps): JSX.Element {
  const { data: participant } = useRead(Participant, assessment.subject)
  return (
    <TimelineTextEntry
      actor={assessment.signer ?? assessment.author}
      time={assessment.date}
      action={
        <>
          {!!assessment.signedOn && 'signed assessment '}
          {!assessment.signedOn &&
            isSameDay(assessment.startsAt, assessment.lastUpdated) &&
            'created assessment '}
          {!assessment.signedOn &&
            !isSameDay(assessment.startsAt, assessment.lastUpdated) &&
            'edited assessment '}
          <TextLink
            to={`${participant?.relativeUrl}/assessments/${assessment.id}`}
          >
            {assessment.title.trim() ? assessment.title.trim() : 'Untitled'}
          </TextLink>
        </>
      }
      reference={assessment.reference}
      originTask={assessment.queuedEditsOriginTask}
    />
  )
}
